import React from "react"
import useAsyncResultIdle from "../../hooks/useAsyncResultIdle"
import {useAccessToken} from "../../services/auth"
import {ProductApplication, approveProductApplication} from "../../resources/productApplication"
import {ApproveApplicationModal} from "./ApplicationApprove"

interface ProductApproveModalProps {
	application: ProductApplication
	close: () => void
	onSuccess: () => void
}

export function ApproveProductApplicationModal({application, close, onSuccess}: ProductApproveModalProps) {
	const accessToken = useAccessToken()
	const [state, approve] = useAsyncResultIdle(approveProductApplication)

	return (
		<ApproveApplicationModal
			title="Approve Product Application"
			close={close}
			onSuccess={onSuccess}
			state={state}
			showRiskRate={false}
			approveFn={(reason) => approve(accessToken, application, reason, application.attributes.updatedAt)}
		/>
	)
}
